export const truncateFileName = (fileName: string) => {
  const fileNameLength = fileName.length;

  if (fileNameLength < 50) return fileName;
  const extensionDelimiterIndex = fileName.lastIndexOf('.');
  const middleRemovedName = `${fileName.substring(0, 40)}...${fileName.substring(
    extensionDelimiterIndex - 3,
  )}`;

  return middleRemovedName;
};
